import kamala from '../../kamala'
import Message from './Message'

Message.install = function (Vue) {
  if (Message.__installed) {
    // eslint-disable-line
    return
  }

  kamala(Vue)

  Vue.prototype.$message = Message.message
  Vue.prototype.$notification = Message.notification
}

export default Message
